module.exports = __webpack_public_path__ + "static/media/media_audio.bbaff39b.ico";